import { useReveal } from '../hooks/useReveal';
import { useBloco, useDados, urlWhatsapp } from '../content';

export default function Contact() {
  const titleRef = useReveal();
  const ctaRef = useReveal();
  const cardsRef = useReveal();
  const mapRef = useReveal();
  const c = useBloco('global.contact');
  const d = useDados();

  const waAdmin = urlWhatsapp('administrativo');
  const emailPrincipal = d.emails[1] || d.emails[0] || '';

  const contactInfo = [
    { l: 'WhatsApp / Telefone', v: d.whatsappAdminLabel || '', href: waAdmin },
    { l: 'E-mail', v: d.emails.join('\n') },
    { l: 'Endereço', v: `${d.endereco.rua}\n${d.endereco.cidade} · ${d.endereco.cep}` },
  ];

  return (
    <section className="contact" id="contato">
      <div className="lbl">{c.eyebrow}</div>
      <h2 className="reveal" ref={titleRef}>{c.heading} <em>{c.headingEm}</em></h2>

      <div className="contact-cta reveal" ref={ctaRef}>
        <a href={waAdmin} target="_blank" rel="noopener noreferrer" className="btn-primary">
          <span>WhatsApp · {d.whatsappAdminLabel} →</span>
        </a>
        <a href={`mailto:${emailPrincipal}`} className="btn-outline">
          {emailPrincipal}
        </a>
      </div>

      <div className="contact-cards reveal" ref={cardsRef}>
        {contactInfo.map((info, i) => (
          <div key={i} className="ci-card">
            <div className="l">{info.l}</div>
            <div className="v">
              {info.href ? (
                <a href={info.href} target={info.href.startsWith('http') ? '_blank' : '_self'} rel="noopener noreferrer">
                  {info.v}
                </a>
              ) : (
                info.v.split('\n').map((line, j, arr) => (
                  <span key={j}>
                    {line.includes('@') ? <a href={`mailto:${line}`}>{line}</a> : line}
                    {j < arr.length - 1 && <br />}
                  </span>
                ))
              )}
            </div>
          </div>
        ))}
      </div>

      <div className="contact-map reveal" ref={mapRef}>
        <iframe
          title={c.mapTitle}
          src={`https://www.google.com/maps?q=${encodeURIComponent(c.mapQuery)}&output=embed`}
          width="100%"
          height="380"
          style={{ border: 0 }}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>

      <div className="social-links">
        {d.instagram && (
          <a href={d.instagram} target="_blank" rel="noopener noreferrer" className="social-btn">
            Instagram ↗
          </a>
        )}
        {d.facebook && (
          <a href={d.facebook} target="_blank" rel="noopener noreferrer" className="social-btn">
            Facebook ↗
          </a>
        )}
      </div>

      <div style={{ borderTop: '1px solid var(--line)', paddingTop: 30, display: 'flex', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16, fontSize: 13, color: 'var(--ink-soft)' }}>
        <div>© {new Date().getFullYear()} HidroAtiva · CNPJ: {d.cnpj} · Todos os direitos reservados</div>
        <div>{c.footerRight}</div>
      </div>
    </section>
  );
}
